export function AgentIcon({ size = 18 }: { size?: number } = {}) {
  return (
    <svg viewBox="0 0 24 24" width={size} height={size} stroke="currentColor" fill="none" strokeWidth={1.2} strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <path d="M12 2.5l8.25 4.75v9.5L12 21.5l-8.25-4.75v-9.5z"/>
      <circle cx="12" cy="12" r="3"/>
    </svg>
  )
}
